module.exports = __webpack_public_path__ + "static/media/octagon.ee45effa.svg";